// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.Select-control {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  width: 100%;
  height: 2.2rem;
}
.Select-control input {
  height: 0;
  line-height: 2rem;
}
.Select-control .Select-value,
.Select-control .Select-input {
  bottom: 0 !important;
  top: inherit !important;
  line-height: 2rem !important;
  height: 2rem;
}

.react-select label {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Form/Select.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAAA;EACE,wBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,WAAA;EACA,cAAA;AAGF;AAFE;EACE,SAAA;EACA,iBAAA;AAIJ;AAFE;;EAEE,oBAAA;EACA,uBAAA;EACA,4BAAA;EACA,YAAA;AAIJ;;AAAE;EACE,gBAAA;AAGJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n\n.Select-control {\n  outline: none !important;\n  border: none !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  width: 100%;\n  height: 2.2rem;\n  input {\n    height: 0;\n    line-height: 2rem;\n  }\n  .Select-value,\n  .Select-input {\n    bottom: 0 !important;\n    top: inherit !important;\n    line-height: 2rem !important;\n    height: 2rem;\n  }\n}\n.react-select {\n  label {\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
